
import React from "react";
import { useNavigate } from "react-router-dom";
import { Create } from "adminApi/HallSeatPlanApi/HallSeatPlan";
import { validateForm } from "utils/validation";
import { HallSeatPlanRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddHallSeatPlanForm from "./Componates/AddHallSeatPlanForm";
import fields from "../json/HallSeatPlanFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";

const AddHallSeatPlan = () => {
  const navigate = useNavigate();
  const { formdata } = fields;

  // Initialize form values from JSON fields
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, handleFileChange, setErrors } = useFormChange(
    initialValues,
    HallSeatPlanRules
  );

  // Form submit
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      delete formValues?.imagePreview;
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      return await Create({ data: formData });
    },
    (vals) => {
      const err = validateForm(vals, HallSeatPlanRules)
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Create Hall Seat Plan successfully"
  );

  return (
    <>
      {(loadingSubmit) && <Spinner isSpinner={true} />}
      <AddHallSeatPlanForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        imagePreview={values.imagePreview || values.image}
        title="Create Hall Seat Plan"
        handleFileChange={handleFileChange}
        formdata={formdata}
      />
    </>
  );
};

export default AddHallSeatPlan;
